import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query';

import api from '../../lib/api';

import { CustomerProductDetail, CustomerProductsParams, CustomerProductsResponse } from './types';

export * from './types';

export function useCustomerProducts(params: CustomerProductsParams) {
  return useQuery({
    queryKey: ['custProducts:list', params],

    queryFn: async () =>
      (
        await api.get('/products', {
          params,
        })
      ).data as CustomerProductsResponse,

    placeholderData: keepPreviousData,
  });
}

export function useCustomerProduct(id?: string, deliveryAddressId?: string) {
  return useQuery({
    queryKey: ['custProducts:get', id, deliveryAddressId ?? null],

    queryFn: async () =>
      (
        await api.get(`/products/${id}`, {
          params: deliveryAddressId
            ? {
                deliveryAddressId,
              }
            : undefined,
        })
      ).data as CustomerProductDetail,

    enabled: Boolean(id),
  });
}

export function useRequestPreviewProduct() {
  return useMutation({
    mutationFn: async ({ productId }: { productId: string }) => {
      const { data } = await api.post(`/products/${productId}/request`);

      return data;
    },
  });
}
